import { inject, Pipe, PipeTransform } from '@angular/core';
import { NewPermission, Permission } from '@core/enums';
import { Store } from '@ngxs/store';
import { UserState } from '@state/user/state';

type PipeablePermissions = Permission | NewPermission;

@Pipe({
  name: 'hasPermission',
  standalone: true,
})
export class HasPermissionPipe implements PipeTransform {
  private readonly store = inject(Store);

  transform(value: PipeablePermissions | PipeablePermissions[], param?: 'all' | 'any'): boolean {
    if (Array.isArray(value)) {
      return this.handlePermissionArray(value, param);
    }

    return this.store.selectSnapshot(UserState.hasPermission(value));
  }

  private handlePermissionArray(value: PipeablePermissions[], param: 'all' | 'any'): boolean {
    if (param === 'any')
      return value.some((permission) => this.store.selectSnapshot(UserState.hasPermission(permission)));

    if (param === 'all')
      return value.every((permission) => this.store.selectSnapshot(UserState.hasPermission(permission)));
  }
}
